import { createInstance, type i18n as I18n } from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import en from './locales/en.json';
import de from './locales/de.json';
import type { Locale } from '../seo/routes';

export const resources = {
  en: { translation: en },
  de: { translation: de },
} as const;

export function createI18n(lng: Locale): I18n {
  const instance = createInstance();

  instance.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: false,
    supportedLngs: ['de', 'en'],
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      throw new Error(`Missing i18n key "${ns}:${key}" for ${lngs.join(', ')}`);
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

  return instance;
}

export function useLocale(): Locale {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'de';
}
